export default "__VITE_ASSET__ef23b989__"